var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserAdmin())?_c('div',[_c('div',{staticClass:"text-2xl"},[_vm._v("\n    Stripe Webhook Responses\n  ")]),_c('StripeList')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }